module.exports = __webpack_public_path__ + "img/0.18e62dfb.png";